import { BOSS_DEFEAT_SCORE } from '../../data/boss';
import type { LevelRun } from '../level-runner';
import { hitBoss } from './boss-fight';
import { isChatoVulnerable } from './chato';
import type { TickContext } from '../tick';

/**
 * A decoy hit on the boss of a run (GDD §9.1, #90 will call it): -1 HP and, on the last one, the comic retreat
 * worth BOSS_DEFEAT_SCORE points. Inside a tick pass its context; outside (test drivers) the events go straight to
 * the listeners and the points to the score. Returns true when the hit counted.
 */
export function hitBossInRun(run: LevelRun, context?: TickContext): boolean {
  const { boss, core } = run;
  if (!boss) return false;
  const events = {
    emit: (input: { type: string; [detail: string]: unknown }) => {
      if (context) context.emit(input);
      else for (const listener of core.listeners) listener({ ...input, tick: core.tick }, core);
    },
  };
  const counted = hitBoss(boss, events);
  if (counted && boss.status === 'retreating') {
    if (context) core.pendingScore += BOSS_DEFEAT_SCORE;
    else core.score += BOSS_DEFEAT_SCORE;
  }
  return counted;
}

/**
 * Whether the boss can be hurt, and hurts, right now. Every boss can in its phases; El Chato (JEFE-4, #133) only while he is out
 * of his tunnel or on the motorbike: hidden, in the dust warning or hiding, a decoy is lost and his body is harmless.
 */
export function isVulnerable(run: LevelRun): boolean {
  if (run.boss?.def.id !== 'JEFE-4') return true;
  return isChatoVulnerable(run.attacks?.chato ?? null);
}
